<template>
  <div class="flex-grow flex-1 flex items-center">
    <gd-dropdown
      v-model="selected"
      :options="options"
      styled="font-family"
      size="full"
      variant="dark"
      class="text-white"
    />
  </div>
</template>

<script>
import GdDropdown from '@groovepages/gd-ui-kit/components/Dropdown';
import tailwindConfig from '@groovepages/gp-page-ui-kit/tailwind';

export default {
  name: 'FontSelector',
  components: {
    GdDropdown,
  },
  props: {
    fontData: {
      default: () => tailwindConfig.fontsData
    },
    value: {
      type: String,
      default: '',
    },
    hideDefault: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(font) {
        this.$emit('input', font);
      },
    },
    options() {
      return Object.keys(this.fontData).map((text) => {
        const option = this.fontData[text];
        return { text, value: option };
      });
    },
  },
};
</script>
